import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=c7ad0a2c&"
import script from "./demo.vue?vue&type=script&lang=ts&"
export * from "./demo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./demo.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports